<script>
// import { ValidationObserver } from 'vee-validate'
// import { services } from '@src/utils/common-services'
// eslint-disable-next-line no-unused-vars
import Autocomplete from 'vuejs-auto-complete'
import { appConfig } from '@src/app.config'

// import { BIcon } from 'bootstrap-vue'
export default {
  components: { Autocomplete },
  props: {
    user: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default() {
        return 'address'
      },
    },
    label: {
      type: String,
      default() {
        return 'Address'
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    value: {
      type: Object,
      default() {
        return null
      },
    },
    api: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      form: [],
      address: {},
      savedData: [],
      storeData: {},
      showList: false,
      index: null,
      restrict: null,
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal && this.value !== null)
        if (Object.keys(this.value).length !== 0) {
          this.storeData = Object.assign({}, this.storeData, this.value)
          this.showList = true
        } else this.storeData = {}
    },
  },
  mounted() {
    //  let apiString = services.apiService(this.api.get, this.user.id, null)
    // this.getData(apiString)

    if (this.value !== null && Object.keys(this.value).length !== 0) {
      this.storeData = Object.assign({}, this.storeData, this.value)
      this.showList = true
    } else this.storeData = {}
  },
  beforeMount() {
    this.form = [
      {
        value: 'houseName',
        name: 'Housename',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: true },
        label: 'Name of GP',
      },
      {
        value: 'streetName',
        name: 'StreetName',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: false },
        label: 'First Line address',

        options: { info: '(This field is optional)' },
      },
      {
        value: 'addressLine',
        name: 'Address line',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: false },
        label: 'Address Line 1 ',
        options: { info: '(This field is optional)' },
      },
      {
        value: 'townCity',
        name: 'Town/City',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: true },
        label: 'Town or City',
      },
      {
        value: 'county',
        name: 'County',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: false },
        label: 'County',
        options: { info: '(This field is optional)' },
      },
      {
        value: 'postalCode',
        name: 'postcode',
        typeComponent: 'FormBaseInputText',
        type: 'text',
        form: 'addresses',
        validation: { required: true },
        label: 'Postcode',
      },
    ]
    /*  this.$watch('storeData',this.saveData,{
      deep:true
    }) */
  },
  beforeDestroy() {
    var doc = this.$refs[this.name + 'address']
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    distributionGroupsEndpoint(input) {
      return (
        'https://api.ideal-postcodes.co.uk/v1/postcodes/' +
        input +
        '?api_key=' +
        appConfig.apiAddressKey
      )
    },
    formattedDisplay(result) {
      // console.log(result)
      return (
        result.line_1 +
        ', ' +
        result.line_2 +
        ',' +
        result.post_town +
        ',' +
        result.county +
        ',' +
        result.postcode
      )
    },

    addDistributionGroup(group) {
      this.group = group

      this.address['houseName'] = group.selectedObject.line_1
      this.address['streetName'] = group.selectedObject.line_2
      this.address['addressLine'] = group.selectedObject.line_3
      this.address['townCity'] = group.selectedObject.post_town
      this.address['county'] = group.selectedObject.county
      this.address['postalCode'] = group.selectedObject.postcode
      this.storeData = Object.assign({}, this.storeData, this.address)
      this.$emit('update', this.storeData)
      // access the autocomplete component methods from the parent
      //  this.$refs.autocomplete.clear()
    },

    sendData(event) {
      //    console.log(event)

      this.storeData[event.name] = event.data
      this.$emit('update', this.storeData)
      //  console.log(this.storeData)
    },
    openModal(name) {
      this.$bvModal.show(name)
    },
    saveData() {
      // var id = this.user.personalInfo.id
      //   console.log(name)

      // if (this.index === null) {
      this.$emit('update', this.storeData)

      /*  let api = services.apiService(this.api.post, this.user.id, null)
            this.postData(api) */
      /*  } else {
            let api = services.apiService(
              this.api.put,
              this.user.id,
              this.storeData['id']
            )
            this.putData(api, this.storeData['id'])
          } */
    },
  },
}
</script>
<template>
  <div :ref="name + 'address'">
    <div class="clear"></div>
    <div :class="$style.guideBoard" class="mt20 ">
      <span :class="$style.guideBoardIcon"></span>
      <p :class="$style.guideBoardText"
        ><b>Note : </b
        >{{ options.info !== undefined ? options.info : 'Address details' }}</p
      >
      <div class="clear"></div>
    </div>

    <div :class="$style.addMainWraper">
      <label :class="$style.fieldTitle" class="w40 w100-sm FL pr15 pr0-sm">{{
        options.title
      }}</label>
      <div
        :class="[$style.addMoreWraper, $style.addmoreAddressWraper]"
        class="mt20"
      >
        <div :class="[$style.autoCompleteWraper, $style.formGroup]" class="p20">
          <Autocomplete
            ref="autocomplete"
            placeholder="Search Postcode"
            :source="distributionGroupsEndpoint"
            results-property="result"
            :results-display="formattedDisplay"
            name="postcodes"
            :show-no-results="false"
            input-class="autoComplete"
            @selected="addDistributionGroup"
          >
          </Autocomplete>
        </div>
        <div :class="$style.form" class="pb30">
          <FormBaseBuilder
            :value="storeData"
            :form="form"
            :user="user"
            @update="sendData"
          />
        </div>
      </div>
    </div>

    <div class="clear"></div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.autoCompleteWraper {
  max-width: 500px;
  background: #fafafa;
  border-radius: 10px;
}

// Instruction message
.guideBoard {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 60px);
  padding: 15px;
  margin-left: -30px;
  background: #fff5f1;

  .guideBoardIcon {
    position: relative;
    float: left;
    width: 45px;
    height: 45px;
    margin-right: 10px;
    background: #b9d3fa;
    border-radius: 50px;

    &::after {
      position: absolute;
      top: 0;
      left: 1px;
      width: 72px;
      height: 72px;
      content: '';
      background: url('~@assets/images/icon.png') no-repeat;
      background-position: 0 0;
      transform: scale(0.61);
      transform-origin: 0 0;
    }
  }

  .guideBoardText {
    float: left;
    width: calc(100% - 55px);
    margin: 8px 0 0;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 12px;
    line-height: 16px;
    color: #757b82;
  }
}
// Instruction message

// Add more wraper set
.addMainWraper {
  .addMoreWraper {
    position: relative;
    float: left;
    width: 100%;
    overflow: hidden;
    background: #fff;
    border-radius: 10px;
  }
}
// Add more wraper set

@media (max-width: 767px) {
  .addMainWraper {
    .addMoreWraper {
      width: 100% !important;
    }
  }
}
</style>
